import * as z from "zod"

export const ProfileBuilderFunctionDbModel = z.object({
  id: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  profileBuilderId: z.string(),
  functionId: z.string(),
})
